import { render } from "./Sensors.vue?vue&type=template&id=2bc653a2"
import script from "./Sensors.vue?vue&type=script&lang=js"
export * from "./Sensors.vue?vue&type=script&lang=js"

import "./Sensors.vue?vue&type=style&index=0&id=2bc653a2&lang=scss"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Sensors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bc653a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc653a2', __exports__)) {
    console.log('reload')
    api.reload('2bc653a2', __exports__)
  }
  
  module.hot.accept("./Sensors.vue?vue&type=template&id=2bc653a2", () => {
    console.log('re-render')
    api.rerender('2bc653a2', render)
  })

}


export default __exports__